module.exports = __webpack_public_path__ + "img/potOutlineRed.70f7dab2.png";